module.exports = __webpack_public_path__ + "img/sound-effect-record.cc69b5a0.png";